export { default as BottomBar } from './component';
